module.exports = __webpack_public_path__ + "static/media/future.47a78fb8.png";